export const EM_DASH = '\u2014';
export const EN_DASH = '\u2013';
